import { EvaluationFlowsEnum, ResultInfo } from "./shared.model";
import { FlowNodeNamesEnum } from "./flow";

export class StepResult {
  runId?: number;
  nodeLogId?: number;
  result: any;
  reasonLog?: string;
  info?: ResultInfo;
  type?: EvaluationFlowsEnum;
  node?: FlowNodeNamesEnum;

  constructor(result: any, reasonLog?: string, info?: ResultInfo, type?: EvaluationFlowsEnum, node?: FlowNodeNamesEnum) {
    this.result = result;
    this.reasonLog = reasonLog;
    this.info = info;
    this.type = type;
    this.node = node;
  }
}
